<template>
  <ModalComponent ref="modal">
    <template #titleText>
      <div class="max-w-full w-[45rem]">Nouvelle zone de livraison</div>
    </template>
    <template #subtitleText>
      <div class="max-w-full w-[45rem]">
        Ajouter une nouvelle zone de livraison
      </div>
    </template>
    <div class="max-w-full w-[45rem] flex flex-col overflow-auto max-h-[75vh]">
      <FormComponent
        class="px-4"
        :fields="[
          {
            type: 'select',
            propertyName: 'country',
            label: 'Pays de livraison',
            defaultValue: '',
            placeHolder: 'Pays de livraison',
            required: true,
            options: this.$Countries.getSignupCountries().sort((ca, cb) => {
              if (ca.countryName > cb.countryName) return 1
              if (ca.countryName < cb.countryName) return -1
              return 0
            }),
            formatOptionInputDisplay(country) {
              return `${country.countryName}`
            },
            formatOptionsDisplay(country) {
              return `${country.countryName}`
            },
            onChanged(newVal) {
              selectedCountry = newVal
              selectedStates = []
              selectedCities = []
              loadCountryCities(newVal.countryCode)
            },
          },
        ]"
      >
        <template #submitButton>
          <button class="hidden" type="submit" ref="submit"></button>
        </template>
      </FormComponent>
      <div class="py-1"></div>
      <div class="overflow-auto h-full px-4">
        <div class="px-2 text-xl font-bold">Départements</div>
        <div
          class="px-2"
          v-if="!selectedCountryStates.length"
          :class="{
            'shimmerElementRoundedDefault rounded-lg min-h-[2lh]':
              !selectedCountryStates.length && selectedCountry?.countryCode,
          }"
        >
          Sélectionnez un pays pour voir les départements
        </div>

        <div class="flex flex-col gap-4" v-if="selectedCountryStates.length">
          <div
            class="flex items-center gap-6 rounded-2xl p-4 ripple"
            :class="{
              'bg-primary-100 ':
                selectedStates.length == selectedCountryStates.length,
              'bg-gray-100 ':
                selectedStates.length !== selectedCountryStates.length,
            }"
            @click="toggleAllStatesSelection()"
          >
            <div>
              Touts les départements ({{ selectedCountryStates.length }})
            </div>
            <div class="ml-auto">
              <div class="w-[1.5rem] h-[1.5rem] relative">
                <div
                  class="duration-300 rounded-full border-2 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                  :class="{
                    'border-primary w-[0.8rem] h-[0.8rem] bg-primary':
                      selectedStates.length == selectedCountryStates.length,
                    'border-primary-300 w-[1.5rem] h-[1.5rem] bg-[transparent]':
                      selectedStates.length !== selectedCountryStates.length,
                  }"
                ></div>
                <div
                  class="duration-300 rounded-full border-2 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                  :class="{
                    'border-primary w-[1.5rem] h-[1.5rem] bg-[transparent]':
                      selectedStates.length == selectedCountryStates.length,
                    'border-[transparent] w-[1.5rem] h-[1.5rem] bg-[transparent]':
                      selectedStates.length !== selectedCountryStates.length,
                  }"
                ></div>
              </div>
            </div>
          </div>
          <div
            v-for="(state, i) in selectedCountryStates"
            :key="i"
            class="flex items-center gap-6 rounded-2xl p-4 ripple"
            :class="{
              'bg-primary-100 ': selectedStates.includes(state),
              'bg-gray-100 ': !selectedStates.includes(state),
            }"
            @click="toggleStateSelection(state)"
          >
            <div>
              {{ state }}
            </div>
            <div class="ml-auto">
              <div class="w-[1.5rem] h-[1.5rem] relative">
                <div
                  class="duration-300 rounded-full border-2 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                  :class="{
                    'border-primary w-[0.8rem] h-[0.8rem] bg-primary':
                      selectedStates.includes(state),
                    'border-primary-300 w-[1.5rem] h-[1.5rem] bg-[transparent]':
                      !selectedStates.includes(state),
                  }"
                ></div>
                <div
                  class="duration-300 rounded-full border-2 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                  :class="{
                    'border-primary w-[1.5rem] h-[1.5rem] bg-[transparent]':
                      selectedStates.includes(state),
                    'border-[transparent] w-[1.5rem] h-[1.5rem] bg-[transparent]':
                      !selectedStates.includes(state),
                  }"
                ></div>
              </div>
            </div>
          </div>
        </div>
        <!-- </div>

      <div class="overflow-auto h-full px-4"> -->
        <div class="py-4"></div>
        <div class="px-2 text-xl font-bold">Villes</div>
        <div
          class="px-2"
          v-if="!countryStateCities.length"
          :class="{
            'shimmerElementRoundedDefault rounded-lg min-h-[2lh]':
              !selectedCountryStates.length && selectedCountry?.countryCode,
          }"
        >
          Sélectionnez un département pour voir les villes
        </div>
        <div class="flex flex-col gap-4" v-else>
          <div
            class="flex items-center gap-6 rounded-2xl p-4 ripple"
            :class="{
              'bg-primary-100 ':
                selectedCities.length == countryStateCities.length,
              'bg-gray-100 ':
                selectedCities.length !== countryStateCities.length,
            }"
            @click="toggleAllCitiesSelection()"
          >
            <!-- <div class="w-20 h-20">
              <img
                :src="city.image"
                class="w-full h-full object-cover rounded-2xl"
                alt=""
              />
            </div> -->
            <div>Toutes les villes ({{ countryStateCities.length }})</div>
            <div class="ml-auto">
              <div class="w-[1.5rem] h-[1.5rem] relative">
                <div
                  class="duration-300 rounded-full border-2 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                  :class="{
                    'border-primary w-[0.8rem] h-[0.8rem] bg-primary':
                      selectedCities.length == countryStateCities.length,
                    'border-primary-300 w-[1.5rem] h-[1.5rem] bg-[transparent]':
                      selectedCities.length !== countryStateCities.length,
                  }"
                ></div>
                <div
                  class="duration-300 rounded-full border-2 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                  :class="{
                    'border-primary w-[1.5rem] h-[1.5rem] bg-[transparent]':
                      selectedCities.length == countryStateCities.length,
                    'border-[transparent] w-[1.5rem] h-[1.5rem] bg-[transparent]':
                      selectedCities.length !== countryStateCities.length,
                  }"
                >
                  <!-- <img
                            src="@/assets/images/all/check-normal-white.svg"
                            alt=""
                          /> -->
                </div>
              </div>
            </div>
          </div>
          <div
            v-for="(city, i) in countryStateCities"
            :key="i"
            class="flex items-center gap-6 rounded-2xl p-4 ripple"
            :class="{
              'bg-primary-100 ': selectedCitiesNames.includes(city.name),
              'bg-gray-100 ': !selectedCitiesNames.includes(city.name),
            }"
            @click="toggleCitySelection(city, i)"
          >
            <!-- <div class="w-20 h-20">
              <img
                :src="city.image"
                class="w-full h-full object-cover rounded-2xl"
                alt=""
              />
            </div> -->
            <div>
              {{ city.name }}
            </div>
            <div class="ml-auto">
              <div class="w-[1.5rem] h-[1.5rem] relative">
                <div
                  class="duration-300 rounded-full border-2 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                  :class="{
                    'border-primary w-[0.8rem] h-[0.8rem] bg-primary':
                      selectedCitiesNames.includes(city.name),
                    'border-primary-300 w-[1.5rem] h-[1.5rem] bg-[transparent]':
                      !selectedCitiesNames.includes(city.name),
                  }"
                ></div>
                <div
                  class="duration-300 rounded-full border-2 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                  :class="{
                    'border-primary w-[1.5rem] h-[1.5rem] bg-[transparent]':
                      selectedCitiesNames.includes(city.name),
                    'border-[transparent] w-[1.5rem] h-[1.5rem] bg-[transparent]':
                      !selectedCitiesNames.includes(city.name),
                  }"
                >
                  <!-- <img
                            src="@/assets/images/all/check-normal-white.svg"
                            alt=""
                          /> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="pt-4 px-4">
        <button
          class="buttonComponent w-full"
          @click="createLocations"
          :class="{
            'pointer-events-none opacity-50': selectedCities.length == 0,
          }"
        >
          Continuer

          <div
            class="top-0 right-0 translate-x-[1rem] -translate-y-1/2 rounded-full absolute px-2 h-6 border border-primary bg-white text-primary"
          >
            {{ selectedCities.length }}&nbsp;Villes
          </div>
        </button>
      </div>
    </div>
  </ModalComponent>
  <EventListener
    :events="[
      'delivery_location_created',
      'failed_to_create_delivery_location',
      'delivery_location_creation_requested',
    ]"
    @delivery_location_created="onDeliveryLocationCreated"
    @failed_to_create_delivery_location="onDeliveryLocationCreationFailed"
    @delivery_location_creation_requested="initDeliveryLocationAdding"
  />
</template>

<script>
import { defineComponent } from 'vue'
import EventListener from '../utils/EventListener.vue'
import ModalComponent from '../utils/ModalComponent.vue'
import FormComponent from '../utils/FormComponent.vue'

export default defineComponent({
  name: 'AddNewDeliveryLocation',
  components: { EventListener, ModalComponent, FormComponent },
  data() {
    return {
      selectedCountry: {},
      countryCities: {},
      countryStates: {},
      selectedStates: [],
      selectedCities: [],
    }
  },
  mounted() {},

  methods: {
    async initDeliveryLocationAdding() {
      this.selectedCountry =  {}
      this.selectedStates =  []
      this.selectedCities =  []
      this.$refs.modal.show()
    },
    onDeliveryLocationCreated(data) {
      let title = 'Zone de livraison ajouté'
      let body = 'La zone de livraison a été ajouté avec succès'
      if (!data.atLeastOneCreated) {
        title = 'Zone de livraison non enrégistré'
        body =
          "Nous n'avons pas pu ajouter la zone de livraison, veuillez réessayer"
      }
      if (data.allDealCreated) {
        title = 'Zone de livraison non enrégistré'
        body = 'Toutes les villes sélectionnés ont été enrégistrée'
      }
      this.$Events.dispatchEvent('finish_loading')
      this.$Events.dispatchEvent('toast_notification', {
        title,
        body,
      })
      this.$router.back()
    },
    onDeliveryLocationCreationFailed() {
      this.$Events.dispatchEvent('finish_loading')
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Zone de livraison non ajouté',
        body: "Erreur d'ajout de la zone de livraison, veuillez réessayer",
      })
    },
    async loadCountryCities(countryCode) {
      if (this.countryCities[countryCode]) return
      const cities = await this.$Events.sendDataRequestResolve(
        'countryCities',
        { countryCode },
      )
      if (!cities) {
        this.$Events.dispatchEvent('toast_notification', {
          title: 'Erreur de récupération',
          body: "Nous n'arrivons pas à récupérer les villes de ce pays. Vérifiez votre connexion et réessayez",
        })
      }
      this.countryCities[countryCode] = cities
      this.countryStates[countryCode] = [
        ...new Set(cities.map(city => city.state)),
      ]
      this.$forceUpdate()
    },
    toggleCitySelection(city) {
      if (this.selectedCitiesNames.includes(city.name)) {
        this.selectedCities.splice(
          this.selectedCitiesNames.indexOf(city.name),
          1,
        )
      } else this.selectedCities.push(city)
    },
    toggleAllCitiesSelection() {
      if (this.selectedCities.length !== this.countryStateCities.length) {
        this.selectedCities = [...this.countryStateCities]
      } else this.selectedCities = []
    },
    toggleStateSelection(state) {
      if (this.selectedStates.includes(state)) {
        this.selectedStates.splice(this.selectedStates.indexOf(state), 1)
      } else this.selectedStates.push(state)
      this.filterCitiesNotInSelectedState()
    },
    toggleAllStatesSelection() {
      if (this.selectedStates.length !== this.selectedCountryStates.length) {
        this.selectedStates = [...this.selectedCountryStates]
      } else this.selectedStates = []
      this.selectedCities = []
    },
    filterCitiesNotInSelectedState() {
      this.selectedCities = this.selectedCities.filter(city =>
        this.countryStateCitiesNames.includes(city.name),
      )
    },
    async createLocations() {
      const details = await this.askDeliveryCost()
      if (!details) return
      const dealsData = {
        ...details,
        cities: this.selectedCities,
      }

      this.$Events.dispatchEvent(
        'many_delivery_location_ready_to_be_added',
        dealsData,
      )
      this.$Events.dispatchEvent('start_loading')
    },
    async askDeliveryCost() {
      const prompt = await this.$Events.sendDataRequestResolve(
        'customPrompt',
        {
          title: 'Configurez le cout de livraison',
          // subTitle: 'Sélectionnez la couleur et sélectionner une image qui y',
          formFields: [
            {
              type: 'number',
              propertyName: 'deliveryCost',
              label: 'Cout de livraison',
              inputProps: {},
              required: true,
            },
            {
              type: 'select',
              propertyName: 'currency',
              inputProps: {
                disabled: true,
              },
              label: 'Devise',
              options: ['XOF' /*  'NGN', 'USD', 'EUR' */],
              defaultValue: 'XOF',
              required: true,
            },
          ],
          successText: 'Sauvegarder',
        },
        9999999999,
      )
      if (!prompt.accepted) return null
      return {
        deliveryCost: prompt.data.deliveryCost,
        currency: prompt.data.currency,
      }
    },
  },
  computed: {
    selectedCountryStates() {
      return this.countryStates[this.selectedCountry?.countryCode] || []
    },
    countryStateCities() {
      if (!this.countryCities[this.selectedCountry?.countryCode]) return []
      const selectedStatesCities = []
      this.selectedStates.forEach(state => {
        const stateCities = this.countryCities[
          this.selectedCountry?.countryCode
        ].filter(city => city.state == state)
        selectedStatesCities.push(...stateCities)
      })
      return selectedStatesCities
    },
    selectedCitiesNames() {
      return this.selectedCities.map(city => city.name)
    },
    countryStateCitiesNames() {
      return this.countryStateCities.map(city => city.name)
    },
  },
})
</script>

<style scoped></style>
